import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { isDoNotTrack, getOtherOptionsFromWindow } from "../../../utils";
import { getUserDecision } from "../../getUserDecision";
/**
 * When the user has "Do not track" enabled and is allowed to use, let's
 * automatically save the dialog without any action.
 */

var preDecisionGatewayIsDoNotTrack = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getOtherOptionsFromW, isRespectDoNotTrack;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), isRespectDoNotTrack = _getOtherOptionsFromW.isRespectDoNotTrack;

            if (!(getUserDecision() !== false || !isRespectDoNotTrack)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", false);

          case 3:
            return _context.abrupt("return", isDoNotTrack() ? "dnt" : false);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewayIsDoNotTrack() {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewayIsDoNotTrack };